import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { AnnualAccountFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import * as Yup from "yup";
import { AnnualAccountOrderK10FormContainerProps } from "models/propTypes/annualAccountPropTypes";
//#endregion
//#region components
import AnnualAccountOrderK10Form from "./orderK10Form";
import { Grid } from "@mui/material";
import { useAnnualAccountService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const AnnualAccountOrderK10FormContainer: ForwardRefRenderFunction<
  FormHandles,
  AnnualAccountOrderK10FormContainerProps
> = (props, ref) => {
  const annualAccountService = useAnnualAccountService();

  const validationSchema = Yup.object<AnnualAccountFormTypes.Comment>({
    message: Yup.string(),
  });

  const handleSubmit = async (values: AnnualAccountFormTypes.Comment) => {
    const result = await annualAccountService.orderK10AnnualAccountReport(props.id, values.message ?? "");
    props.onOrderSuccess?.(result);
    return result;
  };

  return (
    <Grid container direction="column">
      <Grid item className={cssExports.dialogIntroText}>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AnnualAccount.K10OrderDialogIntro)}
      </Grid>
      <Grid item className={cssExports.dialogDescriptionText}>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AnnualAccount.K10OrderInfoText)}
      </Grid>
      <Grid item className={cssExports.dialogPriceRow}>
        <span className={cssExports.dialogPriceLabel}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AnnualAccount.K10OrderPriceLabel)}
        </span>
        <span className={cssExports.dialogPriceValue}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AnnualAccount.K10OrderPriceValue)}
        </span>
      </Grid>
      <Grid item className={cssExports.dialogQuestionText}>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AnnualAccount.K10OrderQuestionText)}
      </Grid>
      <AnnualAccountOrderK10Form
        ref={ref}
        {...props}
        validationSchema={validationSchema}
        defaultValues={{}}
        handleSubmit={handleSubmit}
      />
      <Grid item className={cssExports.dialogHelpText}>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AnnualAccount.K10OrderCommentHelpText)}
      </Grid>
    </Grid>
  );
};

export default forwardRef(AnnualAccountOrderK10FormContainer);
